import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../../Component/Layouts/App/Candidates/StudentApp/Icon';
import { GradientMark, PageHeader, SectionTitle, XpBadge } from '../../../../Component/Layouts/App/Candidates/StudentApp/StudentUi';
import { useStudent } from '../../../../Component/Layouts/App/Candidates/StudentApp/StudentContext';
import { STUDENT_BASE, badges } from '../../../../Component/Layouts/App/Candidates/StudentApp/studentData';

const Achievements = () => {
  const navigate = useNavigate();
  const { xp, showToast } = useStudent();

  return (
    <>
      <PageHeader title="Achievements & Badges" backTo={`${STUDENT_BASE}/profile`} />
      <div className="sa-two">
        <div className="sa-card sa-row">
          <GradientMark name="star" from="#fbbf24" to="#f59e0b" />
          <div>
            <div className="sa-mut">Total XP</div>
            <div className="sa-b" style={{ fontSize: 20 }}>{xp.toLocaleString()}</div>
          </div>
        </div>
        <div className="sa-card sa-row">
          <GradientMark name="award" from="#38bdf8" to="#2563eb" />
          <div>
            <div className="sa-mut">Badges collected</div>
            <div className="sa-b" style={{ fontSize: 20 }}>14 / 50</div>
          </div>
        </div>
      </div>

      <SectionTitle title="My badges" action="See all" />
      <div className="sa-grid3">
        {badges.map((badge) => (
          <button
            type="button"
            key={badge.title}
            className={`sa-badge${badge.locked ? ' lock' : ''}`}
            onClick={() => showToast(`${badge.title}${badge.locked ? ' is locked' : ' unlocked'}`)}
          >
            <GradientMark name={badge.icon} from={badge.from} to={badge.to} />
            {badge.title}
          </button>
        ))}
      </div>

      <SectionTitle title="My achievements" action="+ Upload" onAction={() => showToast('Choose a photo or certificate')} />
      <button type="button" className="sa-card sa-item sa-click" onClick={() => navigate(`${STUDENT_BASE}/achievement`)}>
        <GradientMark name="trophy" from="#fbbf24" to="#f97316" />
        <div className="sa-sp">
          <div className="sa-b" style={{ fontSize: 14 }}>Won 2nd Prize – Inter-College Hackathon</div>
          <div className="sa-mut">
            <Icon name="camera" /> 3 photos · <Icon name="file" /> Certificate
          </div>
          <XpBadge amount={150} />
        </div>
        <Icon name="next" />
      </button>
    </>
  );
};

export default Achievements;
